<div class="collapse" id="navbarToggleExternalContent">
    <div class="bg-dark p-4">
        <h4 class="text-white">Collapsed content</h4>
        <span class="text-muted">Toggleable via the navbar brand.</span>
    </div>
</div>
<nav class="navbar sticky-top navbar-expand-lg shadow-sm border-bottom bg-dark py-1" data-bs-theme="dark">

    <button class="d-none navbar-toggler view-lg top-hidden-menu-btn" type="button" data-bs-toggle="collapse"
        data-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent" aria-expanded="false"
        aria-label="Toggle navigation">
        <fa-icon [icon]='faBars'></fa-icon>
    </button>
    <div style="display: flex; justify-content: center; align-items: center;">
        <a class="navbar-brand" (click)="redirectToHome()">
            <img class="logo" src="https://www.alachisoft.com/images/logo.svg">
        </a>
        <div style="border: 1px solid white; height: 50px; border-radius: 10%;"></div>
        <div style=" padding-left: 14px; min-height: 50px;" >
            <h1 style="font-size: 40px !important; font-weight: bold; color: white; padding: 0%; margin: 0%;">Cloud</h1>
        </div>
    </div>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mt-2 mt-lg-0 user-info-container d-none">
            <li class="nav-item" *ngIf="isAuthenticated" [routerLink]="['/subscription/view/all']"
                routerLinkActive="active">
                Dashboard
            </li>
            <li class="nav-item" *ngIf="isAuthenticated" [routerLink]="['/environment/view/all']"
                routerLinkActive="active">
                Environments
            </li>
            <li class="nav-item" *ngIf="isAuthenticated" [routerLink]="['/reservation/view/all']"
                routerLinkActive="active">
                Reservations
            </li>
        </ul>
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0 text-small">
            <li class="nav-item " *ngIf="isAuthenticated">
                <a class="nav-link active text-center me-lg-4" routerLink="/subscription/dashboard"
                    routerLinkActive="active">
                    <i class="bi bi-house d-block mx-auto mb-1 fs-5"></i>
                    Home
                </a>
            </li>


            <li class="nav-item position-relative" *ngIf="isAuthenticated"
                (click)='isNotificationPanelOpen = !isNotificationPanelOpen; notificationSvc.panelDisplayStatus.next(isNotificationPanelOpen);this.helpService.helpPanelDispalyStatus.next(false);profileService.deletePanelDisplayStatus.next(false);'
                [class.active]='isNotificationPanelOpen'>
                <a class="nav-link text-center me-lg-4" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <span class="active-notifcations text-danger"></span>
                    <i class="bi bi-bell d-block mx-auto mb-1 fs-5"></i>
                    Notifications
                </a>
                <span class="position-absolute translate-middle badge rounded-pill bg-danger mt-1"
                    style="left:60%;top: 0.5rem;" *ngIf="notificationCount > 0">{{notificationCount}}</span>
            </li>


            <li class="nav-item" *ngIf="isAuthenticated && hasFreeTrial"
                [routerLink]="['/subscription/nonce/configuration/']"
                (click)='isNotificationPanelOpen = false; notificationSvc.panelDisplayStatus.next(isNotificationPanelOpen);profileService.deletePanelDisplayStatus.next(false);'
                routerLinkActive="router-link-active">
                <fa-icon [icon]='faUserCog' aria-hidden="true" title="Deployment User Settings"></fa-icon>
            </li>
            <li class="nav-item dropdown me-lg-4" *ngIf="isAuthenticated "
                (click)='isNotificationPanelOpen = false; notificationSvc.panelDisplayStatus.next(isNotificationPanelOpen);profileService.deletePanelDisplayStatus.next(false);'
                routerLinkActive="router-link-active">
                <a class="nav-link dropdown-toggle text-center me-lg-4" href="#" role="button" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    <i class="bi bi-person d-block mx-auto mb-1 fs-5"></i>
                    {{userIdName | async}}
                </a>

                <ul class="dropdown-menu dropdown-menu-end " data-bs-theme="light">
                    <li *ngIf="isAuthenticated " [routerLink]="['/account']"><a class="dropdown-item cursor-pointer"
                            href="#" (click)="$event.preventDefault()">View Profile</a></li>
                    <li>
                        <hr class="dropdown-divider">
                    </li>
                    <li *ngIf="isAuthenticated" (click)='logout()'><a class="dropdown-item fw-bold cursor-pointer"
                            href="#">Logout <i class="ms-1 bi bi-arrow-bar-right"></i></a></li>
                </ul>
            </li>


            <!-- <li class="nav-item user-details text-center" *ngIf="isAuthenticated">
                {{userIdName | async}} <br /><span class="company-name">{{companyName | async}}</span>
            </li>

            <li class="nav-item" *ngIf="isAuthenticated" (click)='logout()'>
                <fa-icon [icon]='faSignOutAlt'></fa-icon> Logout
            </li> -->

            <!-- <div class="dropdown" *ngIf="isAuthenticated">

                <li class="nav-item d-flex flex-row justify-content-center align-items-center" data-bs-toggle="dropdown" aria-expanded="false">

                    <span class="me-2">{{userIdName | async}}</span>

                    <button class="btn btn-primary profile-btn" type="button" id="avatar">

                        <span class="text-secondary">
                            <fa-icon [icon]="faUser"></fa-icon>
                        </span>

                    </button>

                    <ul class="dropdown-menu dropdown-menu-end w-100" aria-labelledby="avatar">

                        <button type="button" class="btn btn-light w-100" (click)='logout()'>Logout</button>

                    </ul>

                </li>

            </div> -->


            <li class="nav-item" *ngIf="!isAuthenticated && showLoginBtn()" [routerLink]="['/auth/login']"
                routerLinkActive="router-link-active">
                <fa-icon [icon]='faSignInAlt'></fa-icon> Login
            </li>
        </ul>

        <ul class="navbar-nav ms-auto mt-2 me-2 mt-lg-0 user-info-container"
            *ngIf="!isAuthenticated && !showLoginBtn()">
            <li class="nav-item">
                <a href="https://www.alachisoft.com/ncache/ncache-cloud.html" target="cloud">Cloud</a>
            </li>
            <li class="nav-item">
                <a href="https://www.alachisoft.com/ncache/" target="software">Software</a>
            </li>
            <li class="nav-item">
                <a href="https://www.alachisoft.com/resources/docs/" target="docs">Documentation</a>
            </li>
        </ul>
    </div>
</nav>
<div class="clearfix"></div>
<!--<nav id="navbar" class="navbar navbar-expand-lg navbar-custom">
    <a class="navbar-brand" href="#">
        <img src="../../assets/NCache-Dashboard-Logo.png">
    </a>
    <app-notifications></app-notifications>
    <p *ngIf='loggedIn'>{{this.username}}</p>
    <app-dropdown-toggle></app-dropdown-toggle>
</nav>-->